import React from "react";

export const Divider = ({ color = "olive", height = "px" }) => (
	<div className={`w-full mb-4 bg-${color} h-${height}`} />
);
